import React from 'react'
import { v, Water, SunRoad, Swells } from './shared'

// The Golden Gate from the Presidio shore: Marin headlands on the left, the
// bridge across the middle, the city on the far shore, Alcatraz in between.

// Suspender cables hang from the main cable, which is a quadratic curve
// from one tower top through a sag point to the other. Computed once.
// The deck sits on the waterline; the whole span sits left of the sun.
const BRIDGE = { x0: 24, t1: 96, t2: 272, x1: 344, top: 254, deck: 297, anchor: 296, sag: 330 }
const SUSPENDERS = (() => {
  const { x0, t1, t2, x1, top, deck, anchor, sag } = BRIDGE
  const out = []
  const quad = (t, a, c, b) => (1 - t) * (1 - t) * a + 2 * (1 - t) * t * c + t * t * b
  for (let x = t1 + 12; x < t2; x += 12) {
    out.push(`M${x},${quad((x - t1) / (t2 - t1), top, sag, top).toFixed(1)} V${deck}`)
  }
  for (let x = x0 + 12; x < t1; x += 12) {
    out.push(`M${x},${quad((x - x0) / (t1 - x0), anchor, 272, top).toFixed(1)} V${deck}`)
  }
  for (let x = t2 + 12; x < x1; x += 12) {
    out.push(`M${x},${quad((x - t2) / (x1 - t2), top, 272, anchor).toFixed(1)} V${deck}`)
  }
  return out.join(' ')
})()

const SKYLINE = [
  // [x, width, height above the horizon]
  [566, 8, 9], [576, 10, 14], [588, 7, 11], [597, 9, 19], [608, 6, 12],
  [616, 11, 25], [629, 8, 16], [662, 9, 22], [673, 12, 38], [687, 7, 18],
  [696, 10, 24], [708, 6, 13], [716, 11, 17], [729, 8, 11], [739, 10, 8],
  [751, 7, 12], [760, 9, 7],
]

const Bay = ({ variant }) => (
  <>
    {/* Marin headlands */}
    <path d="M-10,300 C40,256 110,238 170,250 C215,259 250,282 300,300 Z" className="silhouette-mid" />
    <path d="M110,300 C170,270 230,260 290,272 C330,280 362,294 386,300 Z" style={{ fill: v('sea2') }} opacity="0.55" />

    {/* The city on the far shore, with the pyramid among the towers */}
    <g className="silhouette-mid">
      {SKYLINE.map(([x, w, h]) => <rect key={x} x={x} y={300 - h} width={w} height={h + 2} />)}
      <path d="M642,302 L649,262 L656,302 Z" />
      <rect x="678" y="256" width="2.5" height="7" />
    </g>

    {/* Alcatraz */}
    <g className="silhouette-mid">
      <rect x="540" y="294" width="36" height="7" rx="1.5" />
      <rect x="552" y="288" width="5" height="8" />
      <rect x="561" y="291" width="10" height="5" />
    </g>

    <Water />

    {/* Golden Gate: deck, two towers with their braces, cables, suspenders */}
    <g style={{ stroke: v('boat') }} fill="none" strokeLinecap="round" opacity="0.78">
      <path d={`M${BRIDGE.x0},${BRIDGE.deck} H${BRIDGE.x1}`} strokeWidth="2.8" />
      <path d={[BRIDGE.t1, BRIDGE.t2].map((t) => `M${t - 4.5},302 V${BRIDGE.top} M${t + 4.5},302 V${BRIDGE.top}`).join(' ')} strokeWidth="3" />
      <path d={[BRIDGE.t1, BRIDGE.t2].flatMap((t) => [BRIDGE.top + 12, BRIDGE.top + 26, BRIDGE.top + 40].map((y) => `M${t - 6},${y} H${t + 6}`)).join(' ')} strokeWidth="2.2" />
      <path d={`M${BRIDGE.x0},${BRIDGE.anchor} Q${(BRIDGE.x0 + BRIDGE.t1) / 2},272 ${BRIDGE.t1},${BRIDGE.top} Q${(BRIDGE.t1 + BRIDGE.t2) / 2},${BRIDGE.sag} ${BRIDGE.t2},${BRIDGE.top} Q${(BRIDGE.t2 + BRIDGE.x1) / 2},272 ${BRIDGE.x1},${BRIDGE.anchor}`} strokeWidth="1.8" />
      <path d={SUSPENDERS} strokeWidth="0.7" opacity="0.85" />
    </g>

    <SunRoad />
    <Swells />

    {variant !== 'band' && (
      /* The near shore, and nothing on it. */
      <path d="M0,444 C120,438 260,449 400,442 C540,435 660,447 800,440 L800,500 L0,500 Z" fill="url(#sky-sand)" />
    )}
  </>
)

Bay.label = 'The sun over San Francisco Bay and the Golden Gate, drawn to match the time of day.'

export default Bay
